import { IReportParameter } from "../../module/constants";


export const actionTypes = {
  GET_PARAMETERS: "GET_PARAMETERS",
  GET_PARAMETERS_SUCCESS: "GET_PARAMETERS_SUCCESS",
  GET_PARAMETERS_FAILURE: "GET_PARAMETERS_FAILURE",
  POST_PARAMETER: "POST_PARAMETER",
  POST_PARAMETER_SUCCESS: "POST_PARAMETER_SUCCESS",
  POST_PARAMETER_FAILURE: "POST_PARAMETER_FAILURE",
  PUT_PARAMETER: "PUT_PARAMETER",
  PUT_PARAMETER_SUCCESS: "PUT_PARAMETER_SUCCESS",
  PUT_PARAMETER_FAILURE: "PUT_PARAMETER_FAILURE",
  DELETE_PARAMETER: "DELETE_PARAMETER",
  DELETE_PARAMETER_SUCCESS: "DELETE_PARAMETER_SUCCESS",
  DELETE_PARAMETER_FAILURE: "DELETE_PARAMETER_FAILURE",
};

export const getParametersAction = () => ({
  type: actionTypes.GET_PARAMETERS,
});

export const getParametersSuccess = (response: IReportParameter[]) => ({
  type: actionTypes.GET_PARAMETERS_SUCCESS,
  payload: response,
});

export const getParametersFailure = (err: Error) => ({
  type: actionTypes.GET_PARAMETERS_FAILURE,
  err,
});

export const postParameterAction = (par: IReportParameter) => ({
  type: actionTypes.POST_PARAMETER,
  payload: par,
});

export const postParameterSuccess = (response: any) => ({
  type: actionTypes.POST_PARAMETER_SUCCESS,
  payload: response,
});

export const postParameterFailure = (err: Error) => ({
  type: actionTypes.POST_PARAMETER_FAILURE,
  err,
});

export const putParameterAction = (par: IReportParameter) => ({
  type: actionTypes.PUT_PARAMETER,
  payload: par,
});

export const putParameterSuccess = (response: any) => ({
  type: actionTypes.PUT_PARAMETER_SUCCESS,
  payload: response,
});

export const putParameterFailure = (err: Error) => ({
  type: actionTypes.PUT_PARAMETER_FAILURE,
  err,
});

export const deleteParameterAction = (par: IReportParameter) => ({
  type: actionTypes.DELETE_PARAMETER,
  payload: par,
});

export const deleteParameterSuccess = (response: any) => ({
  type: actionTypes.DELETE_PARAMETER_SUCCESS,
  payload: response,
});

export const deleteParameterFailure = (err: Error) => ({
  type: actionTypes.DELETE_PARAMETER_FAILURE,
  err,
});